import * as React from 'react';
import { Tooltip, Typography } from '@mui/material';

import pinkStamp from '../../img/pinkStamp.png';
import blueStamp from '../../img/blueStamp.png';
import greenStamp from '../../img/greenStamp.png';
import redStamp from '../../img/redStamp.png';
import yellowStamp from '../../img/yellowStamp.png';
import purpleStamp from '../../img/purpleStamp.png';


function Stamp(props){  
  return (
    <div>
      <Tooltip title={props.data.content}>
        { props.data.color === 'pink' ?
        <img src={pinkStamp} alt='pink_stamp' width={130} />
        : props.data.color === 'blue' ?
        <img src={blueStamp} alt='blue_stamp' width={130} />
        : props.data.color === 'green' ?
        <img src={greenStamp} alt='green_stamp' width={130} />
        : props.data.color === 'red' ?
        <img src={redStamp} alt='red_stamp' width={130} />
        : props.data.color === 'yellow' ?
        <img src={yellowStamp} alt='yellow_stamp' width={130} />
        : props.data.color === 'purple' ?
        <img src={purpleStamp} alt='purple_stamp' width={130} />
        : ""}
      </Tooltip>
      <Typography sx={{textAlign: 'right', mt: -2}}>{props.data.date}</Typography>
    </div>
  );
};

export default Stamp;
